import { render } from "./PostActions.vue?vue&type=template&id=42ec3caa&scoped=true"
import script from "./PostActions.vue?vue&type=script&lang=js"
export * from "./PostActions.vue?vue&type=script&lang=js"

import "./PostActions.vue?vue&type=style&index=0&id=42ec3caa&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ec3caa"]])

export default __exports__